// internal
import { UserType } from '@app/store/typings/actions/user.d';
import { UserState } from '@app/store/typings/state/user.d';

const initState: UserState = {
  lists: [],
  listByRoom: [],
  myUser: {
    _id: '',
    title: '',
    firstName: '',
    lastName: '',
    profileName: '',
    profilePicture: '',
    email: '',
    phone: '',
    status: '',
    faceID: '',
    lineId: '',
    username: '',
  },
  inSelectedBrand: [],
  inSelectedProject: [],
  brandMeta: {
    offset: 0,
    limit: 8,
    total: 0,
  },
  projectMeta: {
    offset: 0,
    limit: 8,
    total: 0,
  },
  userMeta: {
    offset: 0,
    limit: 8,
    total: 0,
  },
  brandStatus: false,
  projectStatus: false,
  currentAdmin: {
    _id: '',
    title: '',
    firstName: '',
    lastName: '',
    profileName: '',
    profilePicture: '',
    email: '',
    phone: '',
    status: '',
    faceID: '',
    lineId: '',
    username: '',
  },
  currentUser: {
    _id: '',
    title: '',
    firstName: '',
    lastName: '',
    profileName: '',
    profilePicture: '',
    email: '',
    phone: '',
    status: '',
    faceID: '',
    lineId: '',
    username: '',
  },
  isEditable: undefined,
  searchParam: {
    firstName: '',
    lastName: '',
    email: '',
    status: '',
    sync: '',
    roleName: '',
    groupName: '',
  },
  checkbox: [],
  faceUrl: '',
};

export const user = (state = initState, action: UserType) => {
  switch (action.type) {
    case 'KEY_USER_SELECT_SET_DATA':
      state.lists = [];
      state.lists = action.payload;
      return { ...state };
    case 'KEY_USER_SELECT_SET_DATA_RESERVATION':
      state.listByRoom = [];
      state.listByRoom = action.payload;
      return { ...state };
    case 'KEY_USER_MYUSER_SET_DATA':
      state.myUser = action.payload;
      return { ...state };
    case 'KEY_USER_FETCH_INBRAND':
      state.brandStatus = true;
      return { ...state };
    case 'KEY_USER_INBRAND_SETDATA':
      state.inSelectedBrand = action.payload;
      state.brandStatus = false;
      return { ...state };
    case 'KEY_USER_INBRAND_CLEAR':
      state.inSelectedBrand = [];
      state.currentAdmin = undefined;
      return { ...state };
    case 'KEY_USER_INBRAND_SETCURRENT':
      state.currentAdmin = action.payload;
      return { ...state };
    case 'KEY_USER_BRAND_SETMETA':
      state.brandMeta.offset = action.payload.offset;
      state.brandMeta.limit = action.payload.limit;
      state.brandMeta.total = action.payload.total;
      return { ...state };
    case 'KEY_USER_FETCH_INPROJECT':
      state.projectStatus = true;
      return { ...state };
    case 'KEY_USER_INPROJECT_SETDATA':
      state.inSelectedProject = action.payload.data;
      state.userMeta = action.payload.meta;
      state.projectStatus = false;
      return { ...state };
    case 'KEY_USER_INPROJECT_CLEAR':
      state.inSelectedProject = [];
      state.currentUser = undefined;
      return { ...state };
    case 'KEY_USER_INPROJECT_SETCURRENT':
      state.currentUser = action.payload;
      return { ...state };
    case 'KEY_USER_PROJECT_SETMETA':
      state.projectMeta.offset = action.payload.offset;
      state.projectMeta.limit = action.payload.limit;
      return { ...state };
    case 'KEY_USER_MYUSER_CLEAR':
      state.myUser = undefined;
      return { ...state };
    case 'KEY_USER_SET_IS_EDITABLE':
      state.isEditable = action.payload.isEditable;
      return { ...state };
    case 'KEY_USER_SET_FACE_ID':
      state.faceUrl = action.faceUrl;
      return { ...state };
    case 'KEY_USER_CHECKBOX':
      state.checkbox = action.payload;
      return { ...state };
    default:
      return state;
  }
};
